import { TextField, withStyles } from '@material-ui/core';

/* we have 2 styles for a disabled TextFiled, one is light background for "Use-Case" which is always readonly
  and this one is the darker background which is enabled most of the time and disabled by business logic */
const StyledTextField = withStyles({
  root: {
    '& .MuiFormHelperText-root': {
      textAlign: 'right',
      '&.Mui-disabled': {
        color: '#A8A8A8',
      },
    },
    '&:has(.Mui-disabled)': {
      backgroundColor: '#E6E6E6',
    },
    '& .MuiFormLabel-root.Mui-disabled': {
      color: '#A8A8A8',
    },
  },
})(TextField);

export default StyledTextField;
